import { render, staticRenderFns } from "./changelog-drawer.vue?vue&type=template&id=5d399765&scoped=true&"
import script from "./changelog-drawer.vue?vue&type=script&lang=js&"
export * from "./changelog-drawer.vue?vue&type=script&lang=js&"
import style0 from "./changelog-drawer.vue?vue&type=style&index=0&id=5d399765&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d399765",
  null
  
)

export default component.exports